import { useEffect, useLayoutEffect, useRef } from "react";
import { sendWindowHeight } from "views/utils/CommonFunc";
import * as mb from "../../../common/MessageBox";

interface IFProps {
    type: string,
}

export function Error(props:IFProps): JSX.Element{

    let msg = "";
    const refWindow = useRef<HTMLDivElement>(null);

    useEffect(function(){
        //ウィンドウサイズを呼び出し元に渡す
        sendWindowHeight(refWindow);
    }, []);

    //画面リサイズでウィンドウサイズを呼び出し元に渡す
    useLayoutEffect(function(){
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    });
    function resize(){
        sendWindowHeight(refWindow);
    }

    switch (props.type){
        case "reload_error":
            msg = "お申込処理が中断されました。はじめからやり直してください。";
            break;
        case "token_error":
            msg = "このアドレスには直接アクセスできません。はじめからやり直してください。";
            break;
        case "api_error":
            msg = "ただいま見積サービスはご利用できません。"
            break;
        case "notfound_error":
            msg = "存在しないURLです。"
            break;
    }

    return (
        <div className="order-main" ref={refWindow}>
            <div className="order-width-max">
                <mb.MessageBox args={{type:mb.MSGBOX_TYPE_ERROR, text:msg}}/>
            </div>
            <div className="form-row control-horizon control-center">
                <button className="btn-order btn-secondary btn-icon-left" onClick={function(){window.location.href=process.env.REACT_APP_HOMEPAGEURL+""}}><span className="icon material-icons-round md-18">home</span>トップへ戻る</button>
            </div>
        </div>
    )

}